import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Button, Col, Form, Row, Toast, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import bg1 from "../assets/img/bg1.jpg";
import axios from "../api/axios";
// import { useAuth } from "../hooks/UseAuth";
import { useAuth } from "../hooks/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import CSS for react-toastify
import { loginSucess } from "../redux/user/actions";

const Sigin = () => {
  const [logInInputData, setLogInInputData] = useState({
    username: "",
    password: "",
  });

  const [selectedRole, setSelectedRole] = useState('')
  const { login } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const userRef = useRef();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const dispatch = useDispatch();
  const { email } = useSelector((state) => state.login);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogInInputData((prevState) => ({ ...prevState, [name]: value }));
  };


  // Function to map permissions to routes
  const mapPermissionToRoute = (permission) => {
    const permissionToRouteMap = {
      'BeverageRequest:get': '/request-intend/beverage-request',
      'CentralRequest:get': '/request-intend/central-request',
      'FoodRequest:get': '/request-intend/food-request',
      'Dashboard:get': '/dashboard',
      'Users:get': '/users',
      // Add more mappings as needed
    };

    return permissionToRouteMap[permission] || null;
  };

  // Alternative approach if you want to check for specific preferred routes in order
  const getFirstAccessibleRouteWithPriority = (userAccess) => {
    console.log("User Access:", userAccess);

    console.log("Emaillll :", email);
    

    // if (!userAccess || userAccess.length === 0 ) return "/unauthorized";
    if (email !== 'contact@xpansecafe.com' && (!userAccess || userAccess?.length === 0)) return "/unauthorized";

    // Define your preferred route order
    const preferredRoutes = ['/dashboard', '/food-requests', '/beverage-requests', '/central-requests'];

    // Check for preferred routes in order
    for (let route of preferredRoutes) {
      const requiredPermission = getPermissionFromRoute(route);
      if (userAccess.includes(requiredPermission)) {
        return route;
      }
    }

    // If no preferred routes, return the first accessible route
    const firstRoute = mapPermissionToRoute(userAccess[0]);
    return firstRoute || "/unauthorized";
  };

  // Helper function to get required permission for a route
  const getPermissionFromRoute = (route) => {
    const routeToPermissionMap = {
      '/dashboard': 'Dashboard:get',

      '/request-intend/beverage-request': 'BeverageRequest:get',
      '/request-intend/central-request': 'CentralRequest:get',
      '/request-intend/food-request': 'FoodRequest:get',

      '/users': 'Users:get',

      '/delivery-app/food-delivery-app': 'FoodDeliveryApp:add',

      '/reports/all-reports': '',
      '/reports/customer-reports': 'CustomerReport:get',
      '/reports/order-reports': 'OrdersReport:get',
      '/reports/kiosk-user-reports': 'KioskUserReport:get',
      '/reports/user-analytics-reports': 'UserAnalyticsReport:get',
      '/reports/coupons-report': 'CouponsReport:get',
      '/reports/day-summary-report': 'DaySummaryReport:get',
      '/reports/month-summary-report': 'MonthSummaryReport:get',
      '/reports/product-sales-report': 'ProductSalesReport:get',
      '/reports/user-coupon-report': '',
      '/reports/item-wise-report': 'ItemWiseReport:get',
      '/reports/rm-reorder-report': 'RmReorderLevel:get',
      '/reports/addon-sales-report': 'AddonSalesReport:get',
      '/reports/outlet-stock-report': 'OutletStockReport:get',
      '/reports/storage-location-stock-report': 'StorageLocationStockReport:get',
      '/reports/out-of-stock-product-report': 'ProductOutofStockReport:get',

      '/transaction/central-stock-report': 'CentralStockTransaction:get',
      '/transaction/outlet-stock-report': 'OutletStockTransaction:get',

      '/outlet-management/outlets': 'Outlet:get',
      '/outlet-management/petty-cash': 'PettyCash:get',
      '/outlet-management/outlet-users': 'OutletUser:get',
      '/outlet-management/kiosk-outlet-users': 'KioskUser:get',

      '/menu/category': 'CategoryMgt:get',
      '/menu/add-menu': 'AddMenu:add',
      '/menu/menu-catalog': 'MenuCatalog:get',
      '/menu/menu-ingredients': 'MenuIngredients:get',
      '/menu/menu-addon': 'AddonGroups:get',
      '/menu/product-addon-allocation': 'AddonAllocation:get',

      '/purchase/add-purchase': 'PurchaseList:add',
      '/purchase/local-procurement': '',
      '/purchase/purchase-list': 'PurchaseList:get',
      '/purchase/purchase-units': 'PurchaseUnits:get',
      '/purchase/stock-request': '',
      '/purchase/outlet-stock-transfer': 'OutletStockTransfer:add',
      '/purchase/storage-location-stock-transfer': 'StorageLocationStTransfer:add',
      '/purchase/rm-damage-entries': 'RmDamageEntries:add',
      '/reports/rm-stock-report': '',
      
      '/customer-support-mgt': 'CustomerSupportMgt:get',
      '/cancelation-request': 'CancellationRequest:get',
      '/franchise-enquiry': 'FranchiseEnquiry:get',

      '/content-management/advertisement-mgt': 'AdvertisementMgt:get',
      '/content-management/popup-advertisement': 'PopupAdvertisement:get',
      '/content-management/promote-products': 'PromoteProducts:get',

      '/coupons/offer-of-the-day': '',
      '/coupons/create-coupon': 'Coupons:get',
      '/coupons/coupons-list': 'Coupons:get',
      '/coupons/user-coupon-allocation': 'UserCouponAllocation:get',

      '/system-preference/version-control': 'AppVersion:get',
      '/system-preference/settings': 'Settings:get',
      '/system-preference/logs': 'Logs:get',

      '/user-level/add-level-reward': 'Level:get',
      '/user-level/view-level-reward': 'Level:get',

      '/material-mgt/raw-materials': 'RawMaterials:get',
      '/material-mgt/rm-sub-category': 'RmSubCategory:get',
      '/material-mgt/rm-main-category': 'RmMainCategory:get',

      '/subscription/add-subscription': 'CreateSubscription:add',
      '/subscription/view-subscription': 'Subscriptions:get',
      '/subscription/subscription-users': 'SubscriptionPurchaseReport:get',
      '/subscription/subscription-consumption-report': 'SubscriptionConsumptionReport:get',

    };

    return routeToPermissionMap[route];
  };

  // Function to check if user has access to a specific route
  const hasAccessToRoute = (userAccess, route) => {
    if (!userAccess || userAccess.length === 0) return false;

    const requiredPermission = getPermissionFromRoute(route);
    return userAccess.includes(requiredPermission);
    console.log("Required Permissions :", requiredPermission);
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post("/auth/admin/signin", logInInputData);

      if (response?.data?.status === true) {
        toast.success(response.data.data.message, {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
      }
      console.log("Login Response :", response?.data);

      if (response.data?.data?.user?.passwordExpiry && response.data?.data?.user?.passwordExpiry !== null) {
        dispatch(
          loginSucess({
            token: response?.data?.data?.jwt,
            userId: response?.data?.data?.user?._id,
            userRole: response?.data?.data?.user?.role,
            user: response?.data?.data?.user,
            email: response?.data?.data?.user.email,
            access: response?.data?.data?.user?.access
          })
        );
        navigate("/forgot");
      } else {
        const authToken = response?.data?.data?.jwt;
        login(authToken); // Use context login instead of localStorage directly
        dispatch(
          loginSucess({
            token: response?.data?.data?.jwt,
            userId: response?.data?.data?.user?._id,
            userRole: response?.data?.data?.user?.role,
            user: response?.data?.data?.user,
            email: response?.data?.data?.user.email,
            access: response?.data?.data?.user?.access
          })
        );

        const userData = response?.data?.data?.user;
        const userAccess = userData?.access;

        // navigate("/dashboard");
        localStorage.setItem('authToken', authToken)
        localStorage.setItem('email', response?.data?.data?.user?.email)

        // Check if user has access to dashboard
        if (hasAccessToRoute(userAccess, "/dashboard")) {
          navigate("/dashboard");
        } else if (response?.data?.data?.user.email === "contact@xpansecafe.com") {
          navigate("/dashboard");
        } else {
          // Find the first accessible route with priority
          const firstAccessibleRoute = getFirstAccessibleRouteWithPriority(userAccess);
          console.log("Redirecting to:", firstAccessibleRoute);
          navigate(firstAccessibleRoute);
        }

      }
    } catch (error) {
      if (
        error.response &&
        error.response?.data?.status === false &&
        error.response?.status === 406
      ) {
        let errorMessage = error?.response?.data?.error;

        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
      } else if (
        error.response &&
        error.response?.data?.status === false &&
        error.response?.status === 412
      ) {
        let errorMessage = error?.response?.data?.data?.message;

        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
      } else if (
        error.response &&
        error.response?.data?.status === false &&
        error.response?.status === 404
      ) {
        let errorMessage = error?.response?.data?.data?.message;

        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const disableBtn = !logInInputData?.username?.trim() || !logInInputData?.password?.trim();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  }

  useEffect(() => {
    userRef?.current?.focus();
  }, []);

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign">
            <Card.Header>
              <Link to="/" className="header-logo mb-5">
                xpanse admin
              </Link>
              {/* <Link to="/" className="header-logo mb-5 d-flex align-items-center">
                <img
                  src={require('../pages/Profile.png')}
                  alt="Xpanse Logo"
                  height="40"
                  className="me-2"
                />
                xpanse admin
              </Link> */}
              <Card.Title>Sign In</Card.Title>
              <Card.Text>Welcome back! Please signin to continue.</Card.Text>
            </Card.Header>
            <Card.Body>
              <Form method="get">
                {/* 
                  <div className="mb-4">
                    <Form.Label>Select Your Role</Form.Label>
                    <Form.Select aria-label="Default select example" value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
                      <option value="">Select Role</option>
                      <option value="1">Admin</option>
                      <option value="2">Sub Admin</option>
                      <option value="3">Guest</option>
                    </Form.Select>
                  </div> 
                */}
                <div className="mb-4">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    name="username"
                    type="text"
                    placeholder="Enter your email address"
                    onChange={handleChange}
                    value={logInInputData?.username}
                  />
                </div>
                <div className="mb-4">
                  <Form.Label className="d-flex justify-content-between">
                    Password <Link to="/verify-email">Forgot password?</Link>
                  </Form.Label>
                  <Form.Control
                    name="password"
                    type={passwordVisible ? 'text' : 'password'}  // Toggle between text and password
                    placeholder="Enter your password"
                    onChange={handleChange}
                    value={logInInputData?.password}
                  />
                  <Form.Group
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer", position: "absolute", top: "59%", right: "40px", transform: "translateY(-50%)" }}
                  >
                    {passwordVisible ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye-slash" viewBox="0 0 16 16">
                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                        <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                      </svg>
                    )}
                  </Form.Group>
                </div>
                <Button type="submit" variant="primary" className="btn-sign" onClick={handleSubmit} disabled={isLoading} >
                  {isLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                    </>
                  ) : (
                    "Sign In"
                  )}
                </Button>

                {/* <div className="divider">
                          <span>or sign in with</span>
                          </div> */}

                {/* <Row className="gx-2">
                          <Col>
                              <Button variant="" className="btn-facebook">
                              <i className="ri-facebook-fill"></i> Facebook
                              </Button>
                          </Col>
                          <Col>
                              <Button variant="" className="btn-google">
                              <i className="ri-google-fill"></i> Google
                              </Button>
                          </Col>
                          </Row> */}
              </Form>
            </Card.Body>

          </Card>
        </Col>
        <Col className="d-none d-lg-block">
          <img src={bg1} className="auth-img" alt="" />
        </Col>
      </Row>
    </div>
  );
};

export default Sigin;
